"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9964,2428],{

/***/ 72428:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({
    BASIC_HEADER_HEIGHT: 72,
    SECONDARY_HEADER_HEIGHT: 56,
    HEADER_CONTENT_HORIZONTAL_PADDING: 32,
    MOBILE_MINI_SITE_BASIC_HEADER_HEIGHT: 52,
    MOBILE_MINI_SITE_SECONDARY_HEADER_HEIGHT: 44,
    SIGNUP_POPUP_SCREEN_RIGHT_MARGIN: 16,
    SIGNUP_POPUP_SCREEN_WIDTH: 346,
    SIGNUP_POPUP_SCREEN_HEIGHT: 404,
    PRODUCTS_SWITCHER_SCREEN_WIDTH: 300,
    PRODUCTS_SWITCHER_NEW_USERS_SCREEN_HEIGHT: 375,
    PRODUCTS_SWITCHER_EXISTING_USERS_SCREEN_HEIGHT: 270,
    PRODUCTS_SWITCHER_SCREEN_RIGHT_MARGIN: 32
});


/***/ }),

/***/ 19194:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "TAB_LINE_HEIGHT": function() { return /* binding */ TAB_LINE_HEIGHT; },
  "default": function() { return /* binding */ timeline_titled_tab_tabs_component; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
// EXTERNAL MODULE: ./segments/desktop/core-components/vertical-tabs/vertical-tabs.js + 12 modules
var vertical_tabs = __webpack_require__(54837);
// EXTERNAL MODULE: ./segments/segments-service.js
var segments_service = __webpack_require__(861);
// EXTERNAL MODULE: ./components/core/asset/asset-component.js + 2 modules
var asset_component = __webpack_require__(24961);
// EXTERNAL MODULE: ./segments/desktop/core-components/full-paragraph/full-paragraph.js + 6 modules
var full_paragraph = __webpack_require__(13211);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
// EXTERNAL MODULE: ./segments/desktop/constants.js
var constants = __webpack_require__(73759);
var constants_default = /*#__PURE__*/__webpack_require__.n(constants);
;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/timeline-titled-tab-tabs/timeline-titled-tab-tabs-component.scss.js



var BODY_HORIZONTAL_PADDING = "".concat((constants_default()).BODY_CONTENT_HORIZONTAL_PADDING, "px");
var StyledTimelineTitledTabTabsComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1ve3bus0"
})("max-width:", vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.Ld, "px;margin:auto;.full-paragraph-wrapper{margin-bottom:48px;}display:flex;align-items:center;justify-content:center;.vertical-tabs{width:100%;gap:20px;justify-content:space-between;.desktop-wrapper{width:100%;.vertical-tabs-desktop-component{padding:0 ", BODY_HORIZONTAL_PADDING, ";.vertical-tabs-wrapper{.vertical-tabs{.content{padding-top:0;justify-content:center;flex:1;.asset-and-text{display:flex;flex-direction:column;align-items:center;align-items:stretch;justify-content:space-between;.asset-inner{flex-grow:1;overflow:hidden;img{max-height:100%;height:100%;max-width:100%;width:100%;object-fit:contain;}}.title-wrapper{justify-content:center;flex-shrink:0;overflow:auto;display:flex;align-items:end;width:100%;.asset-title{text-align:center;line-height:24px;height:fit-content;align-items:center;font-size:1rem;}}}}.tabs{width:fit-content;padding-top:0;.tabs-wrapper{.vertical-tab{font-size:1rem;max-width:var(--tab-max-width);line-height:var(--tab-line-height);height:var(--tab-height);&.tab-title{cursor:auto;}&.nested-tab{gap:40px;&.active{gap:36px;.tab-label{font-weight:700;}}}&.active{.vertical-tab-timeline{border-left:3px solid;}}.vertical-tab-timeline{height:100%;margin-right:10px;border:1px solid;}}}}}}}}}");

// EXTERNAL MODULE: ./segments/desktop/core-components/vertical-tabs/default-props.js
var default_props = __webpack_require__(66442);
// EXTERNAL MODULE: ./segments/desktop/core-components/images-grid/images-grid-service.js
var images_grid_service = __webpack_require__(72898);
// EXTERNAL MODULE: ./styles/color-consts.js
var color_consts = __webpack_require__(273);
;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/timeline-titled-tab-tabs/default-props.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}




var tabs = default_props/* default.tabs */.Z.tabs, defaultActiveTabIndex = default_props/* default.defaultActiveTabIndex */.Z.defaultActiveTabIndex, title = default_props/* default.title */.Z.title, rest = _object_without_properties(default_props/* default */.Z, [
    "tabs",
    "defaultActiveTabIndex",
    "title"
]);
var titleDefaultProps = {
    topic: {},
    title: "Streamline workflows, from operational  planning to supply chain management",
    body: "",
    textAlign: "center",
    spaceFromParagraph: "8px"
};
var asset = {
    position: "center",
    fitToContainer: true,
    image: {
        src: "/static/img/segment-layout-default-images/text-and-asset/board-with-dragged-column-in-circle.png"
    }
};
/* harmony default export */ var timeline_titled_tab_tabs_default_props = (_object_spread_props(_object_spread({}, rest), {
    titles: [
        {
            tabsTitle: "Goals",
            tabs: [
                {
                    tabLabel: "Goal management",
                    asset: asset,
                    title: titleDefaultProps
                },
                {
                    tabLabel: "High-level project plan",
                    asset: asset,
                    title: titleDefaultProps
                },
                {
                    tabLabel: "Projects overview",
                    asset: asset,
                    title: titleDefaultProps
                },
                {
                    tabLabel: "Workload management",
                    asset: asset,
                    title: titleDefaultProps
                },
                {
                    tabLabel: "Strategic planning",
                    asset: asset,
                    title: titleDefaultProps
                },
                {
                    tabLabel: "Resource allocation",
                    asset: asset,
                    title: titleDefaultProps
                }
            ]
        },
        {
            tabsTitle: "Projects",
            tabs: [
                {
                    tabLabel: "Project management",
                    asset: asset,
                    title: titleDefaultProps
                },
                {
                    tabLabel: "Operations processes",
                    asset: asset,
                    title: titleDefaultProps
                },
                {
                    tabLabel: "Request management",
                    asset: asset,
                    title: titleDefaultProps
                },
                {
                    tabLabel: "Client projects",
                    asset: asset,
                    title: titleDefaultProps
                }
            ]
        },
        {
            tabsTitle: "Tasks",
            tabs: [
                {
                    tabLabel: "Task management",
                    asset: asset,
                    title: titleDefaultProps
                },
                {
                    tabLabel: "Create a workflow",
                    asset: asset,
                    title: titleDefaultProps
                }
            ]
        }
    ],
    backgroundColor: "light-blue-video-background",
    paddingTop: 0,
    paddingBottom: 0,
    tabsPosition: images_grid_service/* positionTypes.TOP_LEFT */.b.TOP_LEFT,
    minHeight: 0,
    addTimeline: true,
    addTabIndicator: false,
    fullBackground: true,
    lineColor: colors/* default */.Z[color_consts.WHITE_COLOR_NAME]
}));

;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/timeline-titled-tab-tabs/timeline-titled-tab-tabs-component.js

function timeline_titled_tab_tabs_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function timeline_titled_tab_tabs_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            timeline_titled_tab_tabs_component_define_property(target, key, source[key]);
        });
    }
    return target;
}
function timeline_titled_tab_tabs_component_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function timeline_titled_tab_tabs_component_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        timeline_titled_tab_tabs_component_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function timeline_titled_tab_tabs_component_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = timeline_titled_tab_tabs_component_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function timeline_titled_tab_tabs_component_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}









var EMPTY_ASSET_TITLE_PROPS = {
    topic: {},
    body: ""
};
var TAB_LINE_HEIGHT = 40;
var DEFAULT_TITLE = {
    title: ""
};
var DEFAULT_MOBILE_TEXT_AND_ASSET = {
    asset: {},
    fullParagraph: timeline_titled_tab_tabs_component_object_spread_props(timeline_titled_tab_tabs_component_object_spread({}, EMPTY_ASSET_TITLE_PROPS), {
        title: null
    })
};
var TimelineTitledTabTabsComponent = function(_param) {
    var fullBackground = _param.fullBackground, theme = _param.theme, titles = _param.titles, contentHeight = _param.contentHeight, advancedAssetTitleConfig = _param.advancedAssetTitleConfig, titlesColor = _param.titlesColor, contentGap = _param.contentGap, tabAdvancedConfig = _param.tabAdvancedConfig, rest = timeline_titled_tab_tabs_component_object_without_properties(_param, [
        "fullBackground",
        "theme",
        "titles",
        "contentHeight",
        "advancedAssetTitleConfig",
        "titlesColor",
        "contentGap",
        "tabAdvancedConfig"
    ]);
    var getTabTextAndAssetMobileProp = (0,react.useCallback)(function(param) {
        var asset = param.asset, title = param.title;
        return {
            asset: asset,
            fullParagraph: timeline_titled_tab_tabs_component_object_spread({}, EMPTY_ASSET_TITLE_PROPS, title)
        };
    }, []);
    var tabsWithClassNames = (0,react.useMemo)(function() {
        return titles.reduce(function(tabs, title) {
            return (0,_to_consumable_array/* default */.Z)(tabs).concat([
                {
                    tabLabel: title.tabsTitle,
                    tabClassName: "tab-title",
                    isDisabled: true,
                    tabDisabledColor: titlesColor,
                    textAndAsset: DEFAULT_MOBILE_TEXT_AND_ASSET
                }
            ], (0,_to_consumable_array/* default */.Z)(title.tabs.map(function(tab) {
                return timeline_titled_tab_tabs_component_object_spread_props(timeline_titled_tab_tabs_component_object_spread({}, tab), {
                    tabClassName: "nested-tab",
                    textAndAsset: getTabTextAndAssetMobileProp(tab)
                });
            })));
        }, []);
    }, [
        titles,
        titlesColor,
        getTabTextAndAssetMobileProp
    ]);
    var componentHeight = (0,react.useMemo)(function() {
        return contentHeight || "".concat(tabsWithClassNames.length * TAB_LINE_HEIGHT, "px");
    }, [
        contentHeight,
        tabsWithClassNames.length
    ]);
    var tabsTitleRenderer = function() {
        return null;
    };
    var tabContentRenderer = function(param) {
        var asset = param.asset, title = param.title;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "asset-and-text",
            style: {
                height: componentHeight.toString(),
                gap: contentGap
            },
            children: [
                asset && /*#__PURE__*/ (0,jsx_runtime.jsx)(asset_component/* default */.Z, timeline_titled_tab_tabs_component_object_spread_props(timeline_titled_tab_tabs_component_object_spread({}, asset), {
                    style: {
                        padding: "".concat(asset === null || asset === void 0 ? void 0 : asset.assetVerticalPadding, " 0")
                    }
                })),
                title && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "title-wrapper",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(full_paragraph/* default */.ZP, timeline_titled_tab_tabs_component_object_spread(timeline_titled_tab_tabs_component_object_spread_props(timeline_titled_tab_tabs_component_object_spread({}, EMPTY_ASSET_TITLE_PROPS), {
                        titleClassName: "asset-title"
                    }), title, advancedAssetTitleConfig))
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTimelineTitledTabTabsComponent, {
        className: "timeline-titled-tabs-component",
        style: {
            background: fullBackground && colors/* default */.Z[theme],
            "--tab-height": (tabAdvancedConfig === null || tabAdvancedConfig === void 0 ? void 0 : tabAdvancedConfig.tabHeight) || "".concat(TAB_LINE_HEIGHT, "px"),
            "--tab-line-height": tabAdvancedConfig === null || tabAdvancedConfig === void 0 ? void 0 : tabAdvancedConfig.tabLineHeight,
            "--tab-max-width": tabAdvancedConfig === null || tabAdvancedConfig === void 0 ? void 0 : tabAdvancedConfig.tabMaxWidth
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(vertical_tabs/* default */.Z, timeline_titled_tab_tabs_component_object_spread_props(timeline_titled_tab_tabs_component_object_spread({
            fullBackground: fullBackground,
            tabsTitleRenderer: tabsTitleRenderer,
            tabContentRenderer: tabContentRenderer
        }, rest), {
            title: DEFAULT_TITLE,
            tabs: tabsWithClassNames,
            isDarkTheme: (0,segments_service/* isDarkTheme */.$o)(theme)
        }))
    });
};
TimelineTitledTabTabsComponent.defaultProps = timeline_titled_tab_tabs_default_props;
/* harmony default export */ var timeline_titled_tab_tabs_component = (TimelineTitledTabTabsComponent);


/***/ })

}]);